import { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import AddCircleIcon from "@material-ui/icons/AddCircle";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import PersonOutlineIcon from "@material-ui/icons/PersonOutline";
import RemoveCircleOutlineIcon from "@material-ui/icons/RemoveCircleOutline";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import Checkbox from "react-simple-checkbox";

import { dataActions } from "../store/data-slice";
import { stepperActions } from "../store/stepper-slice";
import { screenActions } from "../store/screens-slice";
import { toggleActions } from "../store/toggle-slice";

import { useDispatch } from "react-redux";

import { useTranslation } from "react-i18next";
import { SlideDown } from "react-slidedown";
import "react-slidedown/lib/slidedown.css";

/*
  Component for the element: Elegiré fecha después
*/

const FechaDespues = ({ id, screen, periodo, hideButtons = null }) => {
  const [checkStreaming, setCheckStreaming] = useState(false);
  const [checkPresencial, setCheckPresencial] = useState(true);
  const [completo, setCompleto] = useState(false);
  const [personsNumber, setPersonsNumber] = useState(1);
  const [toggleBottomDiv, settoggleBottomDiv] = useState(false);
  const [toggleSelectButton, setToggleSelectButton] = useState(true);
  const [hideVolverButton, sethideVolverButton] = useState(true);
  const [t] = useTranslation("global");

  const dispatch = useDispatch();

  const fechaDespuesValue = useSelector((state) => state.data.fechaDespues);

  const practicas_data = useSelector((state) => state.data.practicas);

  const elementoSeleccionadoEnPracticas = useSelector(
    (state) => state.data.elementoSeleccionadoEnPracticas
  );

  const elementoSeleccionadoEnTeoria = useSelector(
    (state) => state.data.elementoSeleccionadoEnTeoria
  );

  const disableFechaDespues = useSelector(
    (state) => state.toggle.disableFechaDespues
  );

  const recoverPersonsdValue = () => {
    setPersonsNumber(practicas_data.personas);
  };

  useEffect(() => {
    recoverPersonsdValue();
  }, [practicas_data]);

  useEffect(() => {
    //Recover selected element
    if (screen === "practicas") {
      if (fechaDespuesValue == id) {
        if (
          elementoSeleccionadoEnPracticas == "sin_fecha" ||
          elementoSeleccionadoEnTeoria == "sin_fecha"
        ) {
          setToggleSelectButton(false);
          settoggleBottomDiv(true);
          dispatch(toggleActions.disableClass(true));
          dispatch(toggleActions.disableElements(true));
        }
      }
      sethideVolverButton(true);
    } else if (screen == "teoria") {
      if (
        fechaDespuesValue == id &&
        elementoSeleccionadoEnTeoria == "sin_fecha"
      ) {
        hideButtons(true);
        setToggleSelectButton(false);
        settoggleBottomDiv(true);
        dispatch(toggleActions.disableClass(true));
        dispatch(toggleActions.disableElements(true));
      }
      dispatch(dataActions.setFechaDespues(0));

      sethideVolverButton(false);
    }
  }, [fechaDespuesValue]);

  const handleSelect = () => {
    if (screen === "practicas") {
      dispatch(screenActions.setScrollDivPracticas("#element_fechadespues"));
      dispatch(dataActions.elementoSeleccionadoEnPracticas("sin_fecha"));
    } else if (screen === "teoria") {
      hideButtons(true);
      dispatch(screenActions.setScrollDivTeoria("#element_fechadespues"));
      dispatch(dataActions.elementoSeleccionadoEnTeoria("sin_fecha"));
    }

    setToggleSelectButton(!toggleSelectButton);

    dispatch(toggleActions.disableClass(true));
    dispatch(toggleActions.disableFechaDespues(false));
    dispatch(toggleActions.disableElements(true));

    settoggleBottomDiv(!toggleBottomDiv);
  };

  const handleRemove = () => {
    if (screen === "practicas") {
      dispatch(dataActions.elementoSeleccionadoEnPracticas(""));
    } else if (screen === "teoria") {
      hideButtons(false);
      dispatch(dataActions.elementoSeleccionadoEnTeoria(""));
    }

    dispatch(toggleActions.disableClass(false));

    setToggleSelectButton(!toggleSelectButton);

    dispatch(toggleActions.disableElements(false));

    settoggleBottomDiv(!toggleBottomDiv);
  };

  const handleContinuar = () => {
    if (screen === "practicas") {
      dispatch(dataActions.setFechaDespues(-1));
      dispatch(screenActions.setMainScreen("teoria"));
      dispatch(stepperActions.setActiveStep(1));
      dispatch(toggleActions.disableElements(false));
      dispatch(
        dataActions.applyPracticas({
          periodo,
          personas: personsNumber,
          data: {
            message: t("ELEMENT.day_to_choose"),
          },
        })
      );
    } else if (screen === "teoria") {
      dispatch(dataActions.setFechaDespues(0));
      dispatch(screenActions.setMainScreen("extras"));
      dispatch(stepperActions.setActiveStep(2));
      dispatch(toggleActions.disableElements(false));
      dispatch(
        dataActions.applyTeoria({
          personas: personsNumber,
          data: {
            message: t("ELEMENT.day_to_choose"),
          },
        })
      );
    }

    // Set the inputs of the form to empty to later fill them with the correct values
    const limitEC = Math.ceil(personsNumber / 4);
    dispatch(dataActions.setExtrasInputListCM(Array(personsNumber).fill("")));
    dispatch(dataActions.setExtrasInputListEE(Array(personsNumber).fill("")));
    dispatch(dataActions.setExtrasInputListEC(Array(limitEC).fill({})));
  };

  const handleBackScreen = () => {
    dispatch(dataActions.elementoSeleccionadoEnTeoria(""));
    dispatch(screenActions.setScrollDivTeoria(""));

    dispatch(dataActions.setFechaDespues(-1));
    dispatch(screenActions.setMainScreen("practicas"));
    dispatch(stepperActions.setActiveStep(0));
    dispatch(toggleActions.disableClass(false));
    dispatch(toggleActions.disableElements(false));
  };

  //Toggle tipo de teoria

  //if streaming is selected unselect prensencial
  const handleOnChangeStreaming = (e) => {
    setCheckStreaming(!checkStreaming);
    setCheckPresencial(!checkPresencial);
    dispatch(dataActions.setTipoTeoria("Streaming"));
  };

  //if streaming is selected unselect prensencial
  const handleOnChangePresencial = (e) => {
    setCheckStreaming(!checkStreaming);
    setCheckPresencial(!checkPresencial);
    dispatch(dataActions.setTipoTeoria("Presencial"));
  };

  let toggleButtons;

  if (screen == "practicas") {
    toggleButtons = true;
  } else if (screen === "teoria") {
    toggleButtons = false;
  }

  return (
    <div
      className={
        disableFechaDespues
          ? `element__element element__disable`
          : `element__element`
      }
      id="element_fechadespues"
    >
      <div className="element__top">
        <div className="element__info">
          <p className="element__date">{t("ELEMENT.day_later")}</p>
        </div>
        <div className="element__selecionarEliminarContainer">
          <div className="element__selectionarEliminar">
            {toggleSelectButton ? (
              <>
                <p>{t("ELEMENT.button.select")}</p>
                <button onClick={handleSelect}>
                  <div>
                    <AddCircleIcon style={{ color: "#499BB1", fontSize: 60 }} />
                  </div>
                </button>
              </>
            ) : (
              <>
                <p>{t("ELEMENT.button.remove")}</p>
                <button onClick={handleRemove}>
                  <HighlightOffIcon
                    style={{ color: "#499BB1", fontSize: 60 }}
                  />
                </button>
              </>
            )}
          </div>
        </div>
      </div>
      <SlideDown>
        {toggleBottomDiv && (
          <>
            {screen === "teoria" && (
              <div className="element__tipoTeoria">
                <div className="element__checkContainer">
                  <p>{t("TEORIA.type.presential")}</p>
                  {completo && <span>{t("TEORIA.type.completed")}</span>}
                  <div
                    className={`${
                      completo && "element__checkPresencialCompleto"
                    }`}
                  >
                    <Checkbox
                      checked={true}
                      size={4}
                      color="#499BB1"
                      tickAnimationDuration="100"
                      backAnimationDuration="100"
                      onChange={(e) => {
                        handleOnChangePresencial(e);
                      }}
                    />
                  </div>
                </div>
                {/* <div className="element__checkContainer">
                  <p>{t("TEORIA.type.streaming")}</p>
                  <Checkbox
                    checked={checkStreaming}
                    size={4}
                    color="#499BB1"
                    tickAnimationDuration="100"
                    backAnimationDuration="100"
                    onChange={(e) => {
                      if (!completo) handleOnChangeStreaming(e);
                    }}
                  />
                </div> */}
              </div>
            )}
            <div className="element__bottom">
              {toggleButtons ? (
                <div className="element__icons">
                  <div className="element__profileIcon">
                    <PersonOutlineIcon style={{ fontSize: 30 }} />
                  </div>
                  <div className="element__decrement">
                    <button
                      onClick={() => {
                        setPersonsNumber(personsNumber - 1);
                      }}
                      disabled={personsNumber == 1}
                    >
                      <RemoveCircleOutlineIcon style={{ fontSize: 30 }} />
                    </button>
                  </div>
                  <div className="element__counter">{personsNumber}</div>
                  <div className="element__increment">
                    <button
                      onClick={() => {
                        setPersonsNumber(personsNumber + 1);
                      }}
                      disabled={personsNumber == 10}
                    >
                      <AddCircleOutlineIcon style={{ fontSize: 30 }} />
                    </button>
                  </div>
                </div>
              ) : (
                <div className="element__personContainer">
                  <div className="element__profileIcon">
                    <PersonOutlineIcon style={{ fontSize: 30 }} />
                  </div>
                  <div className="element__counter">
                    {practicas_data.personas}
                  </div>
                </div>
              )}
              <div className="element__buttonsContainer">
                {!hideVolverButton && (
                  <div className="element__volverContainer">
                    <button onClick={handleBackScreen}>
                      {t("ELEMENT.button.back")}
                    </button>
                  </div>
                )}

                <div className="element__continueContainer">
                  <button onClick={handleContinuar}>
                    {t("ELEMENT.button.next")}
                  </button>
                </div>
              </div>
            </div>
          </>
        )}
      </SlideDown>
    </div>
  );
};

export default FechaDespues;
